import * as types from "../actions/actionTypes";
import { getAllOrderLineItemsResponse, getOrderLineItemByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const orderlineitemEntity = createEntitySagas({
  entity: "orderlineitem",
  endpoint: "order-line-items",
  label: "Line item",
  scope: "none",
  quiet: true,
  selectSlice: (state) => state.orderlineitem,
  listKey: "items",
  types: {
    getAll: types.GET_ALL_ORDER_LINE_ITEMS,
    getById: types.GET_ORDER_LINE_ITEM_BY_ID,
    create: types.CREATE_ORDER_LINE_ITEM,
    update: types.UPDATE_ORDER_LINE_ITEM,
    remove: types.DELETE_ORDER_LINE_ITEM,
  },
  actions: { getAllResponse: getAllOrderLineItemsResponse, getByIdResponse: getOrderLineItemByIdResponse },
});

export const orderlineitemSaga = orderlineitemEntity.watcher;
